import { ResourceUpdatePage } from '@/features/access/pages/resource/ResourceUpdatePage'
import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/admin/access/resource/$id/update')({
  beforeLoad({ context }) {
    if (!context.authAdapter.can({ permissions: ["auth_resources.edit"] })) {
      throw redirect({ to: "/403" });
    }
  },
  component: ResourceUpdatePage,
})
